module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/crypto-app-2-192a3698c39f5bd25778ae6bb3eda396.png";